/**
 *    Image zoom
 *
 *    @tableofcontent
 *      1. Dependencies
 *      2. Functions
 *       2.1 Init
 *       2.2 Image swap
 *
 */


/**
 *     @section 1. Dependencies
 */

import Constants from '../settings/_variables';
import Drift from 'drift-zoom';


/**
 *     @section 2. Functions
 */

export default {

    // @section 2.1 Init
    init() {
        // console.log('image zoom loaded ...');

        this.imageZoom();

    },

    // @section 2.2 Image zoom
    imageZoom() {

        // get dom elements
        const $MODAL_ZOOM = $(`.${Constants.prefix}modal--image-zoom`);
        const $BUTTON_OPEN_MODAL = $(`.${Constants.prefix}button--zoom`);
        const $IMAGE_ZOOM_ELEMENT = $('[data-zoom]');
        const $IMAGE_ZOOM_IMAGE = $MODAL_ZOOM.find(`img`);
        const $IMAGE_ZOOM_COPYRIGHT_TARGET = $MODAL_ZOOM.find(`.${Constants.prefix}copyright__inner`);

        // init drift zoom plugin
        let drift = new Drift($IMAGE_ZOOM_ELEMENT[0], {
            containInline: true,
            hoverDelay: Constants.transitionTime,
            paneContainer: $IMAGE_ZOOM_ELEMENT.closest('figure')[0]
        });

        // open modal box and change src attribute
        $BUTTON_OPEN_MODAL.on('click', (event) => {

            // get dom elements
            const $BUTTON = $(event.currentTarget);
            const $ZOOM_IMAGE = $BUTTON.find(`img`);
            const $ZOOM_IMAGE_ELEMENT_WRAP = $BUTTON.closest(`.${Constants.prefix}image__wrap`);
            const ZOOM_IMAGE_ALT = $ZOOM_IMAGE.attr('alt');
            const ZOOM_IMAGE_ELEMENT_COPYRIGHT_TEXT = $ZOOM_IMAGE_ELEMENT_WRAP.find(`.${Constants.prefix}copyright__inner`).text();
            const ZOOM_IMAGE = $BUTTON.data('zoom-image');

            // change image scr
            $MODAL_ZOOM.find('[data-zoom]').attr('src', ZOOM_IMAGE);

            // change zoom image source
            drift.setZoomImageURL(ZOOM_IMAGE);
            $MODAL_ZOOM.find('[data-zoom]').attr('data-zoom', ZOOM_IMAGE);

            // change copyright
            $IMAGE_ZOOM_COPYRIGHT_TARGET.text(ZOOM_IMAGE_ELEMENT_COPYRIGHT_TEXT);

            // change alt attribute
            $IMAGE_ZOOM_IMAGE
                .attr('alt', ZOOM_IMAGE_ALT);

        });

    }
};

// end of _image-zoom.js
